<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { ButtonAll, FieldCreator, FormCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    params: { type: Object, required: true },
    alertId: { type: Number, required: false },
    method: { type: String, default: 'delete' },
    object: { type: Object },
  },

  data() {
    return {
      alert: {},
      def: {},
      validationFields: {},
      validator: false,
      validate: false,
      loadField: false,
      loadForm: false,
      sending: 'patch',
      patchSend: false,
      deleteSend: false,
      formData: null,
    }
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.def = def
      this.alert = obj

      if (obj.type.textParam) {
        for (const [index, alertType] of Object.entries(obj.type.textParam)) {
          this.validationFields[index] = this.getParamsValue(this.object, alertType)
        }
      }

      this.validator = !!(obj.users.some((alertUser) => alertUser.id === user.id) || user.isAdmin)
    },
    transformValue(val) {
      if (typeof val == 'object' && val) {
        let field = ''
        for (const [name, data] of Object.entries(val)) {
          field +=
            '<div class="row"><div class="col font-weight-bold">' +
            name +
            '</div><div class="col">' +
            data +
            '</div></div>\r\n'
        }
        return field
      }
      return val
    },
    isSending(bool) {
      switch (this.sending) {
        case 'delete':
          this.deleteSend = bool
          break
        case 'patch':
          this.patchSend = bool
          break
        default:
      }
    },
    showForm() {
      this.params['id'] = this.alertId
      this.loadForm = true
    },
    openModal() {
      this.$refs[`alert${this.alertId}`].open()
      this.$emit('open-modal')
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs[`alert${this.alertId}`].close(false)
    },
    setDatas(json) {
      this.$emit('validate-sent', this.validate)
      this.$emit('alert-sent', json)
      this.closeModal()
    },
    patchAlert(onlyValidation) {
      this.sending = onlyValidation ? 'patch' : 'delete'
      this.$refs.myformalert.datas['validationFields'] = JSON.stringify(this.validationFields)
      if (onlyValidation) {
        this.$refs.myformalert.errors.comment = false
        this.$refs.myformalert.datas['onlyValidation'] = onlyValidation
      }

      this.$refs.myformalert.methods('patch')
    },
  },
}
</script>
<template>
  <div>
    <ModalDialog
      :id="'alert' + alertId"
      :ref="'alert' + alertId"
      class-modal-dialog="modal-xl"
      @icon-close="closeModal"
      e2e-modal="alert"
    >
      <FormCreator
        @update-data="updateData"
        v-if="loadForm"
        ref="myformalert"
        endpoint="alerts"
        :id="alertId"
        :params="params"
        send-params
        in-modal
        class-to-add="d-none"
        @modal-build="openModal"
        @form-build="setBuild"
        @element-build="setElement"
        @form-return="setDatas"
        @is-sending="isSending"
      />
      <template #body>
        <div v-if="Object.keys(validationFields).length > 0">
          <h5>{{ $t('alert.validation.title') }}</h5>
          <div class="row" v-for="(value, key) in validationFields">
            <div class="col font-weight-bold">{{ getFieldLabel(null, null, key) }}</div>
            <div class="col" v-html="transformValue(value)"></div>
          </div>
        </div>
        <div class="row">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="comment"
            form-ref="myformalert"
            domain="alert"
            label-top
            editor
          />
        </div>
      </template>
      <template #footer>
        <div class="mt-3">
          <ButtonAll
            v-if="validator"
            margin="no"
            :loading="patchSend"
            type="validation"
            @click="patchAlert(true)"
            label="alert.validate"
            e2e-button="updateAlert"
          />
          <ButtonAll
            v-if="validator"
            margin="no"
            class="mx-3"
            :loading="deleteSend"
            type="validation"
            @click="patchAlert(false)"
            label="alert.archive"
            e2e-button="deleteAlert"
          />
          <ButtonAll margin="no" type="default" @click="closeModal" label="main.close" e2e-button="close" />
        </div>
      </template>
    </ModalDialog>
  </div>
</template>
